import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const { CONFIG_LIST, LOADER_IDENTIFIER, CALL_STATE } = STATE_IDENTIFIER;

export default {
  [LOADER_IDENTIFIER]: false,
  [CONFIG_LIST]: [],
  [CALL_STATE]: IResponseState.PENDING,
};
